export class QueryStringParser {
    static getUrlQueryObject = (search: string): Record<string, $TSFixMe> => Object.fromEntries(new URLSearchParams(search));

    static getUrlQueryStr = (urlParams: { [k: string]: string }): string => {
        const urlParamsStr = new URLSearchParams(urlParams).toString();
        return urlParamsStr ? `?${urlParamsStr}` : '';
    };
}
